import { DropdownItem } from '@shared/abstraction';
import { TransactionType } from '@shared/helpers/enums/transaction-type';

export const transactionTypeMapItems: DropdownItem[] = [
  {
    value: TransactionType.GeneralRates,
    label: 'General rates',
  },
  {
    value: TransactionType.SpecificAdvice,
    label: 'Specific advice',
  },
];
